var _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConversationhandedtoagent(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.418 13.4937V32.9243C46.418 41.3747 41.3723 46.418 32.9243 46.418H13.4937C5.04563 46.418 0 41.3747 0 32.9243V13.4937C0 5.04331 5.04563 0 13.4937 0H32.9243C41.3723 0 46.418 5.04331 46.418 13.4937Z",
    fill: "url(#paint0_linear_3497_3084)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9137 10C28.0043 10 24.8242 12.5264 24.8242 15.5665C24.8242 16.8173 25.3811 18.0281 26.3996 19.0105V21.8682C26.3996 22.159 26.5597 22.4259 26.8158 22.5629C27.0687 22.6986 27.3804 22.6863 27.6243 22.5237L30.0944 20.8774C30.7298 21.0136 31.3283 21.0805 31.9137 21.0805C35.823 21.0805 39.0031 18.6066 39.0031 15.5665C39.0031 12.5264 35.823 10 31.9137 10ZM28.7628 16.3542C28.3278 16.3542 27.9751 16.0015 27.9751 15.5665C27.9751 15.1315 28.3278 14.7788 28.7628 14.7788C29.1978 14.7788 29.5505 15.1315 29.5505 15.5665C29.5505 16.0015 29.1978 16.3542 28.7628 16.3542ZM31.9137 16.3542C31.4786 16.3542 31.1259 16.0015 31.1259 15.5665C31.1259 15.1315 31.4786 14.7788 31.9137 14.7788C32.3487 14.7788 32.7014 15.1315 32.7014 15.5665C32.7014 16.0015 32.3487 16.3542 31.9137 16.3542ZM35.0645 16.3542C34.6295 16.3542 34.2768 16.0015 34.2768 15.5665C34.2768 15.1315 34.6295 14.7788 35.0645 14.7788C35.4995 14.7788 35.8522 15.1315 35.8522 15.5665C35.8522 16.0015 35.4995 16.3542 35.0645 16.3542Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9648 16.8477C16.0569 16.8477 13.6328 19.2131 13.6328 22.1211C13.6328 25.029 16.0569 27.3945 18.9648 27.3945C21.8728 27.3945 24.2969 25.029 24.2969 22.1211C24.2969 19.2131 21.8728 16.8477 18.9648 16.8477Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6943 27.3403C22.4497 28.4542 20.7663 29.1523 18.9687 29.1523C17.1712 29.1523 15.4878 28.4542 14.2432 27.3403C12.287 28.7817 11 31.0826 11 33.6936V37.1211C11 37.6069 11.3931 38 11.8789 38H26.0586C26.5444 38 26.9375 37.6069 26.9375 37.1211V33.6936C26.9375 31.0826 25.6505 28.7817 23.6943 27.3403Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3497_3084",
    x1: 10,
    y1: 51.5,
    x2: 46,
    y2: -8.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00624724,
    stopColor: "#1964D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6DFFFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConversationhandedtoagent);
export default __webpack_public_path__ + "static/media/conversationhandedtoagent.49d4f47ed0383cebced5514896ca9014.svg";
export { ForwardRef as ReactComponent };